import { Observable} from 'rxjs/Observable';
import get from 'lodash/get';
import 'rxjs/add/operator/share';

declare var global;
const GEOLOCATION_API = get(global, 'navigator.geolocation', {
	watchPosition: (() => ({})) as any,
	getCurrentPosition: (() => ({})) as any,
	clearWatch: (watchId) => {}
});

function watchPosition(options) {
	return Observable.create(observer => {
		// get a low accuracy position quickly, and narrow down with watchPosition
		GEOLOCATION_API.getCurrentPosition(
			data => observer.next(data),
			data => observer.next(data),
			{maximumAge: 60000, timeout: 5000, enableHighAccuracy: false}
		)
		const next = data => observer.next(data)
    const watchId = GEOLOCATION_API.watchPosition(next, next, options)
		return () => GEOLOCATION_API.clearWatch(watchId)
	}).share()
}

export default watchPosition;



// WEBPACK FOOTER //
// ./src/app/models/Location/locate.ts